<div class="layout-sidebar-right" [ngClass]="{'layout-sidebar-right-active': appMain.rightMenuActive}"
     (click)="appMain.rightMenuClick = true">
    <p>Right Menu</p>
</div>
